import {renderStructuredElements} from "@/utils/render-helpers.jsx";
import {product as productStore} from "@/store/Product";
import {price as priceStore} from "@/store/Price";
import JSON5 from "json5";
import ProductPrice from "@/components/ProductPage/ProductPrice";
import ProductForm from "@/components/ProductPage/ProductForm";
import ProductGallery from "@/components/ProductPage/ProductGallery";

document.addEventListener("DOMContentLoaded", () => {
  const initProductStore = () => {
    const el = document.querySelector('[data-store-id="product"]');
    const data = JSON5.parse(el.dataset.storeData);
    productStore.setVariantId(data.variantId);
  };

  const initPriceStore = () => {
    const el = document.querySelector('[data-store-id="price"]');
    const data = JSON5.parse(el.dataset.storeData);
    priceStore.setPricesData(data);
  };

  initProductStore();
  initPriceStore();

  renderStructuredElements("product-gallery", ProductGallery);
  renderStructuredElements("product-price", ProductPrice, {
    stores: {
      productStore,
      priceStore,
    },
  });
  renderStructuredElements("product-form", ProductForm, {
    stores: {productStore},
  });
});
